import React, { Component } from "react"

/* Icons */
import { CaretDownOutlined } from '@ant-design/icons'

/* Constants */
import { env, utils } from "../constants"

/* Components */
import { Picture } from "@cuba-go/poker-ui"

/* Moment */
import moment from "moment"
import 'moment/locale/ru'
moment.locale('ru')


/* Component History */
class NiuHistory extends Component {

    constructor() {
        super()

        this.state = {
            active: -1
        }
    }


    makeArray = (value) => {

        if (!value) return []

        if (Array.isArray(value)) return value

        return String(value)
            .split(',')
            .filter(Boolean)
            .map(n => Number(n))
    }


    /* Determine and draw total */
    _total = data => {

        let total = 0
        let currency = "USD"

        if (data.transactions && Array.isArray(data.transactions) && data.transactions.length > 0) {

            data.transactions.forEach(transaction => {

                if (transaction.type === 'credit') {
                    total = total + parseFloat(transaction.total)
                }

                if (transaction.type === 'debit') {
                    total = total - parseFloat(transaction.total)
                }

                currency = transaction.currency

            })

        }

        if (total > 0) {
            return <div className="history-head-total">+ {utils.convertor(Math.abs(total), currency)}</div>
        }

        if (total < 0) {
            return <div className="history-head-total">- {utils.convertor(Math.abs(total), currency)}</div>
        }

        return <div className="history-head-total">{utils.convertor(total, currency)}</div>
    }


    /* Draw time */
    _time = data => {

        if (data.createdAt) {

            const date = moment(data.createdAt).format("YYYY-MM-DD")
            const today = moment(new Date()).format("YYYY-MM-DD")

            const yesterdayD = new Date()
            yesterdayD.setDate(yesterdayD.getDate() - 1)
            const yesterday = moment(yesterdayD).format("YYYY-MM-DD")

            let text = date

            if (moment(date).isSame(today, 'day')) {
                text = 'Сегодня'
            }
            else if (moment(date).isSame(yesterday, 'day')) {
                text = 'Вчера'
            }

            return (
                <div className="history-head-datetime">
                    <div className="history-head-time">{moment(data.createdAt).format("HH:mm")}</div>
                    <div className="history-head-date">{text}</div>
                </div>
            )
        }
    }


    /* Draw cards */
    _cards = data => {

        const boxes = this.makeArray(data.boxes)

        let dealer = []
        let player = []
        let position = []

        /* Cards */
        if (Array.isArray(data.cards) && data.cards.length > 0) {
            data.cards.forEach(card => {
                if (card.type === "dealer") {
                    dealer.push(card)
                }
                if (card.type === "player") {
                    player.push(card)
                }
                /* The one pulled before the deal to say which box it starts at */
                if (card.type === "position") {
                    position.push(card)
                }
            })
        }

        const boxCards = (array, box) => {
            return array.filter(c => c && c.box && parseInt(c.box) === parseInt(box))
        }

        /* A hand belongs to a box, or to the dealer — never to a player, since everyone
           at the table shares the same three box hands */
        const gameResult = (type, box = 0) => {
            const i = data.results.findIndex(e => e && (type === 'dealer'
                ? e.type === 'dealer'
                : parseInt(e.box) === parseInt(box)))

            if (i !== -1) {
                return data.results[i].result
            }

            return null
        }

        return (
            <div className="modal-boxes niuniu">
                <div className="game-result-cards">
                    <div className="rmp--modal-box-item" style={{ margin: "0px 0px 10px" }}>
                        {position.length > 0 ? <div className="modal-box-text"><p>Карта раздачи</p></div> : null}
                        <div className="modal-cards">
                            {position.map((card, index) =>
                                <div key={`${index}`} className="modal-card-item">
                                    <Picture src={`${env.mediapoint}/cards/${card.image}`} alt="Card" />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="game-result-cards">
                    <div className="rmp--modal-box-item">
                        {dealer.length > 0 ? <div className="modal-box-text"><p>Карты дилера</p></div> : null}
                        <div className="modal-cards">
                            {dealer.map((card, index) =>
                                <div key={`${index}`} className="modal-card-item">
                                    <Picture src={`${env.mediapoint}/cards/${card.image}`} alt="Card" />
                                </div>
                            )}
                        </div>
                        <div className="modal-box-result">{gameResult('dealer')}</div>
                    </div>
                </div>
                <div className="game-result-cards">
                    {boxes.map(box => {

                        const cards = boxCards(player, box)

                        return (
                            <div className="rmp--modal-box-item" key={`box-cards-${box + 1}`}>
                                {cards.length > 0 ? <div className="modal-box-text"><p>Бокс - {box}</p></div> : null}
                                <div className="modal-cards">
                                    {cards.map((card, index) =>
                                        <div key={`${index}`} className="modal-card-item" style={{ opacity: card.status === "hidden" ? 0.5 : 1 }}>
                                            <Picture src={`${env.mediapoint}/cards/${card.image}`} alt="Card" />
                                        </div>
                                    )}
                                </div>
                                <div className="modal-box-result">{gameResult('player', box)}</div>
                            </div>
                        )
                    })}

                </div>
            </div>
        )

    }


    /* Draw current game */
    _currentGame = () => {

        /* Props and state */
        const { info, transactions } = this.props
        const { active } = this.state

        if (info && transactions && Array.isArray(transactions) && transactions.length > 0) {
            return (
                <div className="history-item">

                    {/* Draw history head */}
                    <div onClick={() => this.setState({ active: active === 'current' ? -1 : 'current' })} className={`history-head ${'current' === active ? 'history-active-head' : ''}`}>

                        <div className="history-number">
                            Игра #{info.number}
                            <div className="history-number-text"> (ТЕКУЩАЯ ИГРА)</div>
                        </div>

                        <div className="history-head-right">
                            <CaretDownOutlined />
                        </div>

                    </div>

                    <div className={`history-hidden-box ${'current' === active ? 'history-hidden-box-active' : ''}`}>

                        {(transactions && Array.isArray(transactions) && transactions.length > 0) &&
                            <div className="history-transactions">
                                <table className="operations-table">
                                    <thead>
                                        <tr>
                                            <th>Вид ставки</th>
                                            <th>Значение</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {transactions.map((transaction, index) =>
                                            <tr key={`h-o-${index}`} className="item">
                                                <td>{transaction.reason}</td>
                                                <td>{utils.convertor(transaction.total, transaction.currency)}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        }
                    </div>
                </div>
            )
        }

        return null
    }

    /* WHAT ONE BOX ACTUALLY COST AND GAVE BACK

       A stake's own line says what that stake won or lost. The hold is a different thing
       and belongs to the box rather than to any one stake: a Super Double is held at
       fifteen times its face, so the money that leaves the balance when the bets go down
       is nothing like the sum of the faces, and the round hands the unspent part back at
       the end. Both numbers are written down per box when the round is settled, so they
       are read from there rather than worked out from the stakes and a coefficient. */
    boxMoney = (item, box) => {

        const list = item.bets && Array.isArray(item.bets) ? item.bets : []
        const bet = list.find(e => parseInt(e.box) === parseInt(box))

        if (!bet) {
            return null
        }

        return {
            held: parseFloat(bet.reserve ? bet.reserve : 0),
            back: parseFloat(bet.win ? bet.win : 0),
        }
    }

    /* One stake's result, which is a loss as often as it is a win */
    netAmount = value => {

        const { currency } = this.props

        const amount = parseFloat(value ? value : 0)

        if (!amount) {
            return <span className="niu-net">{utils.convertor(0, currency)}</span>
        }

        return (
            <span className={`niu-net ${amount > 0 ? "niu-net-win" : "niu-net-lose"}`}>
                {amount > 0 ? "+" : "\u2212"}{utils.convertor(Math.abs(amount), currency)}
            </span>
        )
    }

    /* Operations list */
    operationsList = (item, index) => {

        const { currency } = this.props

        const boxes = this.makeArray(item.boxes)

        if (item.processes && Array.isArray(item.processes) && item.processes.length > 0) {

            let total = 0
            let totalWin = 0

            /* Only the stakes count towards what was staked — a maxpay note and a refund
               are things the round did afterwards, not money the player put on the cloth */
            item.processes.forEach(process => {
                if (process.total && process.type !== 'maxpay' && process.type !== 'refund') {
                    total += parseFloat(process.total)
                }
                if (process.win) {
                    totalWin += parseFloat(process.win)
                }
            })

            let gameProcesses = [[], [], []]

            boxes.forEach((box) => {
                const boxIndex = box - 1 >= 0 ? box - 1 : 0
                gameProcesses[boxIndex] = item.processes.filter((e) => parseInt(e.box) === parseInt(box) && e.type !== 'refund')
            })

            const refundList = item.processes.filter(e => e.type === 'refund')

            return (
                <div className="history-transactions" key={`o-t-${index}`}>
                    <table className="operations-table">
                        <thead>
                            <tr>
                                <th>Вид ставки</th>
                                <th>Cтавка</th>
                                <th>Итог</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                gameProcesses.map((array, ind) => {

                                    if (array.length === 0) {
                                        return null
                                    }

                                    const boxNumber = ind + 1
                                    const money = this.boxMoney(item, boxNumber)

                                    return (
                                        <React.Fragment key={`h-box-${boxNumber}`}>

                                            {/* The box carries what was taken for it and what came back — the
                                                stakes below it carry only what each of them did */}
                                            <tr className="item niu-box-line">
                                                <td colSpan={3}>
                                                    Бокс - {boxNumber}
                                                    {money ?
                                                        <span className="niu-box-money">
                                                            удержано {utils.convertor(money.held, currency)}
                                                            <i>·</i>
                                                            возврат {utils.convertor(money.back, currency)}
                                                        </span>
                                                        : null}
                                                </td>
                                            </tr>

                                            {array.map((process, i) => {

                                                if (process.type === 'maxpay') {
                                                    return (
                                                        <tr key={`h-o-${boxNumber}-${i}`} className="item gold">
                                                            <td colSpan={3}>Вам выплатили максимальную сумму - {utils.convertor(process.total, currency)}</td>
                                                        </tr>
                                                    )
                                                }

                                                return (
                                                    <tr key={`h-o-${boxNumber}-${i}`} className="item">
                                                        <td>{process.reason}</td>
                                                        <td>{utils.convertor(process.total, currency)}</td>
                                                        <td>{this.netAmount(process.win)}</td>
                                                    </tr>
                                                )
                                            })}

                                        </React.Fragment>
                                    )
                                })
                            }

                            {
                                refundList.map((process, i) =>
                                    <tr key={`h-o-refund-${i}`} className="item refund">
                                        <td>Возврат</td>
                                        <td colSpan={2}>{utils.convertor(process.total, currency)}</td>
                                    </tr>
                                )
                            }

                            <tr key={`h-o-total`} className="niu-total-line">
                                <td>Итого</td>
                                <td>{utils.convertor(total, currency)}</td>
                                <td>{this.netAmount(totalWin)}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            )
        }

        return null
    }

    render = () => {

        /* Props and state */
        const { visible, close, histories, loadMore, historyHasMore, always } = this.props
        const { active } = this.state

        /* Fields */
        const animated = visible ? 'animated' : ''
        const bottomStyle = histories.length > 10 ? 'initial' : ''


        return (
            <div className={`modal history ${always} ${animated}`}>
                <div className='modal-content'>

                    {/* Modal Header */}
                    <div className='modal-header'>
                        История игры
                        <div onClick={() => close()} className="modal-close">
                            <Picture src={`${env.mediapoint}/images/x.png`} alt="CLOSE" />
                        </div>
                    </div>

                    {/* Modal Body */}
                    <div className='modal-body'>

                        {/* The current game */}
                        {this._currentGame()}

                        {/* Old games */}
                        {histories.map((item, index) => {

                            let endBalance = parseFloat(item.startBalance)

                            if (item.transactions && Array.isArray(item.transactions) && item.transactions.length > 0) {
                                item.transactions.forEach(transaction => {
                                    if (transaction.type === 'credit') {
                                        endBalance = endBalance + parseFloat(transaction.total)
                                    }
                                    if (transaction.type === 'debit') {
                                        endBalance = endBalance - parseFloat(transaction.total)
                                    }
                                })
                            }

                            return (
                                <div className="history-item" key={`${index}`}>

                                    {/* Draw history head */}
                                    <div onClick={() => this.setState({ active: active === index ? -1 : index })} className={`history-head ${index === active ? 'history-active-head' : ''}`}>

                                        <div className="history-number">
                                            Игра #{item.number}
                                            {/* {index === 0 && <div className="history-number-text"> (LAST GAME)</div>} */}
                                        </div>

                                        <div className="history-head-right">
                                            {this._total(item)}
                                            {this._time(item)}
                                            <CaretDownOutlined />
                                        </div>

                                    </div>

                                    <div className={`history-hidden-box ${index === active ? 'history-hidden-box-active' : ''}`}>

                                        {item.dealer ? <div className="history-dealer">Дилер: {item.dealer}</div> : null}

                                        {item.endReason ? <div className="history-reason-error">{item.endReason}</div> : null}

                                        {(item.transactions && Array.isArray(item.transactions) && item.transactions.length > 0) &&
                                            <div className="history-transactions">

                                                {(item.startBalance !== null || item.startBalance !== undefined) && <div className="history-transaction-balance">Баланс до игры: {utils.convertor(item.startBalance, item.transactions[0].currency)}</div>}
                                                {endBalance > 0 && <div className="history-transaction-balance">Баланс после игры: {utils.convertor(endBalance, item.transactions[0].currency)}</div>}

                                                {this.operationsList(item, index)}

                                            </div>
                                        }

                                        {this._cards(item)}

                                    </div>
                                </div>
                            )
                        })}

                        {historyHasMore &&
                            <div className={`modal-bottom ${bottomStyle}`}>
                                <div className="modal-load-more" onClick={() => loadMore()}>Загрузить еще</div>
                            </div>
                        }

                        <div className="modal-bottom-space" />

                    </div>
                </div>
            </div>

        )

    }

}

export default NiuHistory